import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.759 16.95a4.92 4.92 0 0 1-.7.05H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6.1c0 .238-.017.471-.05.7-.313 2.146-2.04 3.844-4.191 4.15ZM14.6 11.4V6A1.6 1.6 0 0 0 13 4.4H7A1.6 1.6 0 0 0 5.4 6v8A1.6 1.6 0 0 0 7 15.6h3.359v-1.5a2.7 2.7 0 0 1 2.7-2.7H14.6Zm-2.841 4.13V14.1a1.3 1.3 0 0 1 1.3-1.3h1.469a3.549 3.549 0 0 1-2.77 2.73Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.169 6.293a.7.7 0 0 1 .025.99l-.563.591H12.2a.7.7 0 1 1 0 1.4H9.631l.563.592a.7.7 0 0 1-1.015.965L7.493 9.057a.7.7 0 0 1 0-.965l1.686-1.774a.7.7 0 0 1 .99-.025Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=BackToSheetIcon20.js.map